module.exports = "https://milano-network.servercdn.it/static/fonts/FuturaPT-Heavy.ttf?8b9416a7a903a8734f22e4fd043f74e9";